import { useEffect } from 'react';

import { useLocation, useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';
import { formatTimeForFilterObject } from '@usas/ui-web/utils/TimesUtils';

import UseForm from "@usas/ui-web/utils/UseForm";
import Constants from '@usas/ui-web/utils/Constants';
import useEventCompetitionGenderTypeData from '@usas/ui-web/state/eventCompetitionGender/UseEventCompetitionGenderTypeData';

import useTimeValidationData from '../../../state/timeValidation/UseTimeValidationData';

import NavLinks from '../NavLinks';
import validate from './TimesValidationDetailValidation';

//todo: get from DB
const genderOptions = [
  { id: 1, name: "Male", value: 1 },
  { id: 2, name: "Female", value: 2 },
  { id: 3, name: "Mixed", value: 3 }];

const useMeetValidationDetail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const { putUpdateInvalidTime } = useTimeValidationData();
  const { eventCompetitionGenderState } = useEventCompetitionGenderTypeData();

  const { formState, errorState, setFormData, handleSubmit, onFormValueChanged, setIsDirty, onValueTextPairChanged
  } = UseForm(getInitialFormState(), submitFormCallback, validate);

  function submitFormCallback(formState) {
    const invalidTimeObj = { 
      swimTimeRecognitionId: location.state?.invalidTime.swimTimeRecognitionId,
      memberId: formState.memberId,
      swimTime: formatTimeForFilterObject(formState.time),
      lscCodeFromFile: formState.lscCode,
      clubCodeFromFile: formState.clubCode,
      eventCompetitionGenderTypeId: formState.eventCompetitionGenderTypeId
    };

    const putUpdateInvalidTimePromise = putUpdateInvalidTime(location.state?.invalidTime.swimTimeRecognitionId, invalidTimeObj);

      if (putUpdateInvalidTimePromise !== null) {
        putUpdateInvalidTimePromise.then((newState) => {
          if (newState !== null) {
            navigate(NavLinks.MEET_TIMES_VALIDATION);
          }
        }).catch((e) => {
          //setContextStateError(true);
        });
      }
  };

  const onBackButtonClicked = () => {
    navigate(NavLinks.MEET_TIMES_VALIDATION);
  };

  useEffect(() => {
    if (location.state) {
      let genderTypeId = location.state?.invalidTime.eventCompetitionGenderTypeId || 1;
      setFormData({
        ...formState,
        memberId: location.state?.invalidTime.memberId || '',
        time: location.state?.invalidTime.swimTime || '',
        lscCode: location.state?.invalidTime.lscCodeFromFile || '',
        clubCode: location.state?.invalidTime.clubCodeFromFile || '',
        isRelay: location.state?.invalidTime.eventCode.includes('-R'),
        eventCompetitionGenderTypeId: genderTypeId,
        eventCompetitionGenderTypeName: genderOptions[genderTypeId - 1].name
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  function getInitialFormState() {
    return ({
      memberId: '',
      time: '',
      lscCode: '',
      clubCode: '',
      isRelay: false,
      eventCompetitionGenderTypeId: Constants.DEFAULT_ID,
      eventCompetitionGenderTypeName: '--'
    })
  };

  return {
    formState,
    errorState,
    handleSubmit,
    setFormData,
    onFormValueChanged,
    onBackButtonClicked,
    onValueTextPairChanged,
    eventCompetitionGenderState,
    genderOptions
  }
}

export default useMeetValidationDetail;